import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { FaEdit } from "react-icons/fa";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { useNavigate } from "react-router-dom";
import GiftsArtsdetails from "../ProductGiftsAndArts/SingleProductGiftsAndArts"

function TabViewGiftsAndArts() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showEditDialog, setShowEditDialog] = useState(false);
  const [showAddDialog, setShowAddDialog] = useState(false);

  const [productID, setProductID] = useState("");
  const [productName, setProductName] = useState("");
  const [sellingPrice, setSellingPrice] = useState("");
  const [genericName, setGenericName] = useState("");
  const [numberOfSeats, setNumberOfSeats] = useState("");
  const [description, setDescription] = useState("");
  const [type, setType] = useState("");
  const [color, setColor] = useState("");
  const [deliveryCondition, setDeliveryCondition] = useState("");
  const [seatbeltIncluded, setSeatbeltIncluded] = useState(false);
  const [otherPowerFeatures, setOtherPowerFeatures] = useState("");
  const [notCoveredInWarranty, setNotCoveredInWarranty] = useState("");
  const [otherConvenienceFeatures, setOtherConvenienceFeatures] = useState("");
  const [coveredInWarranty, setCoveredInWarranty] = useState("");
  const [mpThreePlayerSupported, setMpThreePlayerSupported] = useState(false);
  const [maximumUserWeight, setMaximumUserWeight] = useState("");
  const [stockAvailability, setStockAvailability] = useState(true);
  const [categoryID, setCategoryID] = useState("");
  const [modelNumber, setModelNumber] = useState("");
  const [ageGroup, setAgeGroup] = useState("");
  const [brand, setBrand] = useState("");
  const [price, setPrice] = useState("");
  const [netQuantity, setNetQuantity] = useState("");
  const [warrenty, setWarrenty] = useState("");
  const [speed, setSpeed] = useState("");
  const [dimentions, setDimentions] = useState("");
  const [countryOfOrigin, setCountryOfOrigin] = useState("");
  const [lights, setLights] = useState("");
  const [horn, setHorn] = useState("");
  const [weight, setWeight] = useState("");
  const [manufacturer, setManufacturer] = useState("");
  const [batteryIncluded, setBatteryIncluded] = useState(false);
  const [noOfBatteries, setNoOfBatteries] = useState("");
  const [batteryOperated, setBatteryOperated] = useState(false);
  const [batteryType, setBatteryType] = useState("");
  const [parentalRemote, setParentalRemote] = useState(false);
  const [keyStart, setKeyStart] = useState(false);
  const [rechargeable, setRechargeable] = useState(false);
  const [quantity, setQuantity] = useState("");

  const [visibleDialog, setVisibleDialog] = useState(false);
  const [selectedProductID, setSelectedProductID] = useState(null);

  const fetchAllGiftsAndToys = async () => {
    setLoading(true);
    try {
      const response = await fetch("/allGiftsAndArts");
      const result = await response.json();
      setProducts(result);
    } catch (err) {
      console.error("Error fetching data:", err);
      setProducts([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllGiftsAndToys();
  }, []);

  const storeTbleDataInVariables = (rowData) => {
    setProductID(rowData.productID);
    setCategoryID(rowData.categoryID);
    setProductName(rowData.productName);
    setDescription(rowData.description);
    setPrice(rowData.price);
    // setSellingPrice(rowData.sellingPrice);
    setGenericName(rowData.genericName);
    setBrand(rowData.brand);
    setModelNumber(rowData.modelNumber);
    setType(rowData.type);
    setAgeGroup(rowData.ageGroup);
    setMaximumUserWeight(rowData.maximumUserWeight);
    setNetQuantity(rowData.netQuantity);
    setSpeed(rowData.speed);
    setDeliveryCondition(rowData.deliveryCondition);
    setNumberOfSeats(rowData.numberOfSeats);
    setBatteryOperated(rowData.batteryOperated);
    setNoOfBatteries(rowData.noOfBatteries);
    setBatteryIncluded(rowData.batteryIncluded);

    setRechargeable(rowData.rechargeable);
    setBatteryType(rowData.batteryType);
    setOtherPowerFeatures(rowData.otherPowerFeatures);
    setKeyStart(rowData.keyStart);
    setSeatbeltIncluded(rowData.seatbeltIncluded);
    setMpThreePlayerSupported(rowData.mpThreePlayerSupported);
    setParentalRemote(rowData.parentalRemote);
    setLights(rowData.lights);
    setHorn(rowData.horn);
    setOtherConvenienceFeatures(rowData.otherConvenienceFeatures);
    setDimentions(rowData.dimentions);
    setWeight(rowData.weight);
    setCountryOfOrigin(rowData.countryOfOrigin);
    setManufacturer(rowData.manufacturer);
    setWarrenty(rowData.warrenty);
    setCoveredInWarranty(rowData.coveredInWarranty);
    setNotCoveredInWarranty(rowData.notCoveredInWarranty);
    setColor(rowData.color);
    setQuantity(rowData.quantity);
    setStockAvailability(rowData.stockAvailability);
    fetchAllGiftsAndToys();
    //  fetchFileByCaseID();
  };

  const handleSubmitAddGiftsAndArts = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("/insertOrUpdateCars", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          incidentUpdateID: null,
          insertOrUpdate: "InsertInBothTables",
          productID: productID,
          categoryID: parseInt(categoryID),
          productName: productName,
          description: description,
          price: parseFloat(price),
          sellingPrice: parseFloat(sellingPrice),
          genericName: genericName,
          brand: brand,
          modelNumber: modelNumber,
          type: type,
          ageGroup: ageGroup,
          maximumUserWeight: maximumUserWeight,
          netQuantity: parseInt(netQuantity),
          speed: speed,
          deliveryCondition: deliveryCondition,
          numberOfSeats: parseInt(numberOfSeats),
          batteryOperated: true,
          noOfBatteries: parseInt(noOfBatteries),
          batteryIncluded: true,
          rechargeable: true,
          batteryType: batteryType,
          otherPowerFeatures: otherPowerFeatures,
          keyStart: keyStart,
          seatbeltIncluded: true,
          mpThreePlayerSupported: true,
          parentalRemote: true,
          lights: true,
          horn: true,
          otherConvenienceFeatures: otherConvenienceFeatures,
          dimentions: dimentions,
          weight: weight,
          countryOfOrigin: countryOfOrigin,
          manufacturer: manufacturer,
          warrenty: warrenty,
          coveredInWarranty: coveredInWarranty,
          notCoveredInWarranty: notCoveredInWarranty,
          color: color,
          quantity: parseInt(quantity),
          stockAvailability: stockAvailability,
        }),
      });
      const data = await response.text();
      console.log("Success:", data);
      if (response.ok) {
        alert("Car Added successfully");
        setShowAddDialog(false);
        fetchAllGiftsAndToys();
      } else if (!response.ok) {
        const errorText = await response.text();
        console.error("Bad Request:", errorText);
        alert("Failed to Add cars");
        throw new Error("Request failed");
      }
    } catch (err) {
      console.error("API call error:", err);
    }
  };

  const handleSubmitUpdate = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("/updateCars", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          incidentUpdateID: null,
          insertOrUpdate: "UpdatingCarsAndInventory",
          productID: productID,
          categoryID: parseInt(categoryID),
          productName: productName,
          description: description,
          price: parseFloat(price),
          sellingPrice: parseFloat(sellingPrice),
          genericName: genericName,
          brand: brand,
          modelNumber: modelNumber,
          type: type,
          ageGroup: ageGroup,
          maximumUserWeight: maximumUserWeight,
          netQuantity: parseInt(netQuantity),
          speed: speed,
          deliveryCondition: deliveryCondition,
          numberOfSeats: parseInt(numberOfSeats),
          batteryOperated: true,
          noOfBatteries: parseInt(noOfBatteries),
          batteryIncluded: true,
          rechargeable: true,
          batteryType: batteryType,
          otherPowerFeatures: otherPowerFeatures,
          keyStart: keyStart,
          seatbeltIncluded: true,
          mpThreePlayerSupported: true,
          parentalRemote: true,
          lights: true,
          horn: true,
          otherConvenienceFeatures: otherConvenienceFeatures,
          dimentions: dimentions,
          weight: weight,
          countryOfOrigin: countryOfOrigin,
          manufacturer: manufacturer,
          warrenty: warrenty,
          coveredInWarranty: coveredInWarranty,
          notCoveredInWarranty: notCoveredInWarranty,
          color: color,
          quantity: parseInt(quantity),
          stockAvailability: stockAvailability,
        }),
      });
      const data = await response.text();
      console.log("Success:", data);
      if (response.ok) {
        alert("Car updated successfully");
        setShowEditDialog(false);
        fetchAllGiftsAndToys();
      } else if (!response.ok) {
        const errorText = await response.text();
        console.error("Bad Request:", errorText);
        alert("Failed to update car");
        throw new Error("Request failed");
      }
    } catch (err) {
      console.error("API call error:", err);
    }
  };

  const handleEditRowClick = (rowData) => {
    return (
      <>
        <Button
          onClick={() => {
            storeTbleDataInVariables(rowData);
            setShowEditDialog(true);
          }}
          text>
          <FaEdit />
        </Button>
      </>
    );
  };

  const navigate = useNavigate();

  return (
    <div>
      <Dialog
        header="Product Details"
        visible={visibleDialog}
        onHide={() => setVisibleDialog(false)}
        dismissableMask
        modal
        className="custom-dialog"
        style={{ width: "95vw", maxWidth: "900px" }} // Responsive width
      >
        <div
          style={{
            maxHeight: "80vh",
            // overflowY: "auto",
          }}
        >
          <GiftsArtsdetails />
        </div>
      </Dialog>
      <Dialog
        visible={showAddDialog}
        onHide={() => setShowAddDialog(false)}
        header="Add GiftsAndArts Details"
      >
        <h3 className="mt-4 pb-1 border-bottom-1 surface-border text-xl text-800">
          General
        </h3>
        <div className="flex gap-3">
          <div className="flex flex-column">
            <label htmlFor="productID">Product</label>
            <InputText
              id="productID"
              type="text"
              value={productID}
              onChange={(e) => setProductID(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="categoryID">CategoryID</label>
            <InputText
              id="categoryID"
              type="text"
              value={categoryID}
              onChange={(e) => setCategoryID(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productName">ProductName</label>
            <InputText
              id="productName"
              type="text"
              value={productName}
              onChange={(e) => setProductName(e.target.value)}
            />
          </div>
        </div>
        <div className="flex gap-3">
          <div className="flex flex-column">
            <label htmlFor="productID">Description</label>
            <InputText
              type="text"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">Price</label>
            <InputText
              type="text"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">selling Price</label>
            <InputText
              type="text"
              value={sellingPrice}
              onChange={(e) => setSellingPrice(e.target.value)}
            />
          </div>
        </div>
        <div className="flex gap-3">
          <div className="flex flex-column">
            <label htmlFor="productID">GenericName</label>
            <InputText
              type="text"
              value={genericName}
              onChange={(e) => setGenericName(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">brand</label>
            <InputText
              type="text"
              value={brand}
              onChange={(e) => setBrand(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">ModelNumber</label>
            <InputText
              type="text"
              value={modelNumber}
              onChange={(e) => setModelNumber(e.target.value)}
            />
          </div>
        </div>
        <h3 className="mt-4 pb-1 border-bottom-1 surface-border text-xl text-800">
          Convenience Features
        </h3>
        <div className="flex gap-3">
          <div className="flex flex-column">
            <label htmlFor="productID">Type</label>
            <InputText
              type="text"
              value={type}
              onChange={(e) => setType(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">Age</label>
            <InputText
              type="text"
              value={ageGroup}
              onChange={(e) => setAgeGroup(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">Maximum Weight</label>
            <InputText
              type="text"
              value={maximumUserWeight}
              onChange={(e) => setMaximumUserWeight(e.target.value)}
            />
          </div>
        </div>
        <div className="flex gap-3">
          <div className="flex flex-column">
            <label htmlFor="productID">NetQuantity</label>
            <InputText
              type="text"
              value={netQuantity}
              onChange={(e) => setNetQuantity(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">Speed</label>
            <InputText
              type="text"
              value={speed}
              onChange={(e) => setSpeed(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">Delivery Condition</label>
            <InputText
              type="text"
              value={deliveryCondition}
              onChange={(e) => setDeliveryCondition(e.target.value)}
            />
          </div>
        </div>

        <div className="flex gap-3">
          <div className="flex flex-column">
            <label htmlFor="productID">Other Power Details</label>
            <InputText
              type="text"
              value={otherPowerFeatures}
              onChange={(e) => setOtherPowerFeatures(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">Key Start</label>
            <InputText
              type="text"
              value={keyStart}
              onChange={(e) => setKeyStart(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">Seat Belt Included</label>
            <InputText
              type="text"
              value={seatbeltIncluded}
              onChange={(e) => setSeatbeltIncluded(e.target.value)}
            />
          </div>
        </div>
        <div className="flex gap-3">
          <div className="flex flex-column">
            <label htmlFor="productID">mp3Player</label>
            <InputText
              type="text"
              value={mpThreePlayerSupported}
              onChange={(e) => setMpThreePlayerSupported(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">ParentalRemote</label>
            <InputText
              type="text"
              value={parentalRemote}
              onChange={(e) => setParentalRemote(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">lights</label>
            <InputText
              type="text"
              value={lights}
              onChange={(e) => setLights(e.target.value)}
            />
          </div>
        </div>
        <h3 className="mt-4 pb-1 border-bottom-1 surface-border text-xl text-800">
          Power Features
        </h3>
        <div className="flex gap-3">
          <div className="flex flex-column">
            <label htmlFor="productID">No Of Seats</label>
            <InputText
              type="text"
              value={numberOfSeats}
              onChange={(e) => setNumberOfSeats(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">BatteryOperated</label>
            <InputText
              type="text"
              value={batteryOperated}
              onChange={(e) => setBatteryOperated(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">No Of Batteries</label>
            <InputText
              type="text"
              value={noOfBatteries}
              onChange={(e) => setNoOfBatteries(e.target.value)}
            />
          </div>
        </div>
        <div className="flex gap-3">
          <div className="flex flex-column">
            <label htmlFor="productID">Battry Included</label>
            <InputText
              type="text"
              value={batteryIncluded}
              onChange={(e) => setBatteryIncluded(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">Rechargable</label>
            <InputText
              type="text"
              value={rechargeable}
              onChange={(e) => setRechargeable(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">Battery Type</label>
            <InputText
              type="text"
              value={batteryType}
              onChange={(e) => setBatteryType(e.target.value)}
            />
          </div>
        </div>

        <h3 className="mt-4 pb-1 border-bottom-1 surface-border text-xl text-800">
          Dimensions
        </h3>
        <div className="flex gap-3">
          <div className="flex flex-column">
            <label htmlFor="productID">Horn</label>
            <InputText
              type="text"
              value={horn}
              onChange={(e) => setHorn(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">OtherFeatures</label>
            <InputText
              type="text"
              value={otherConvenienceFeatures}
              onChange={(e) => setOtherConvenienceFeatures(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">Dimentions</label>
            <InputText
              type="text"
              value={dimentions}
              onChange={(e) => setDimentions(e.target.value)}
            />
          </div>
        </div>
        <div className="flex gap-3">
          <div className="flex flex-column">
            <label htmlFor="productID">Weight</label>
            <InputText
              type="text"
              value={weight}
              onChange={(e) => setWeight(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">Country</label>
            <InputText
              type="text"
              value={countryOfOrigin}
              onChange={(e) => setCountryOfOrigin(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">Manufacter</label>
            <InputText
              type="text"
              value={manufacturer}
              onChange={(e) => setManufacturer(e.target.value)}
            />
          </div>
        </div>

        <div className="flex gap-3">
          <div className="flex flex-column">
            <label htmlFor="productID">Color</label>
            <InputText
              type="text"
              value={color}
              onChange={(e) => setColor(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">Quantity</label>
            <InputText
              type="text"
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">Stock Availability</label>
            <InputText
              type="text"
              value={stockAvailability}
              onChange={(e) => setStockAvailability(e.target.value)}
            />
          </div>
        </div>
        <h3 className="mt-4 pb-1 border-bottom-1 surface-border text-xl text-800">
          Warranty
        </h3>
        <div className="flex gap-3">
          <div className="flex flex-column">
            <label htmlFor="productID">warrenty</label>
            <InputText
              type="text"
              value={warrenty}
              onChange={(e) => setWarrenty(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">Coverd In warrenty</label>
            <InputText
              type="text"
              value={coveredInWarranty}
              onChange={(e) => setCoveredInWarranty(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">NotCoverd In Warrenty</label>
            <InputText
              type="text"
              value={notCoveredInWarranty}
              onChange={(e) => setNotCoveredInWarranty(e.target.value)}
            />
          </div>
        </div>
        <Button
          type="submit"
          onClick={(e) => {
            handleSubmitAddGiftsAndArts(e);
          }}
          label="Submit"
        />
      </Dialog>
      <Dialog
        visible={showEditDialog}
        onHide={() => setShowEditDialog(false)}
        header="Edit GiftsAndArts Details"
      >
        <div className="flex gap-3">
          <div className="flex flex-column relative">
            <label htmlFor="productID">Product</label>
            <div className="relative">
              <InputText
                id="productID"
                type="text"
                className="pl-10"
                value={productID}
                onChange={(e) => setProductID(e.target.value)}
              />
            </div>
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">categoryID</label>
            <InputText
              type="text"
              value={categoryID}
              onChange={(e) => setCategoryID(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">productName</label>
            <InputText
              type="text"
              value={productName}
              onChange={(e) => setProductName(e.target.value)}
            />
          </div>
        </div>

        <div className="flex gap-3">
          <div className="flex flex-column">
            <label htmlFor="productID">Description</label>
            <InputText
              type="text"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">Price</label>
            <InputText
              type="text"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">selling Price</label>
            <InputText
              type="text"
              value={sellingPrice}
              onChange={(e) => setSellingPrice(e.target.value)}
            />
          </div>
        </div>

        <div className="flex gap-3">
          <div className="flex flex-column">
            <label htmlFor="productID">GenericName</label>
            <InputText
              type="text"
              value={genericName}
              onChange={(e) => setGenericName(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">brand</label>
            <InputText
              type="text"
              value={brand}
              onChange={(e) => setBrand(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">ModelNumber</label>
            <InputText
              type="text"
              value={modelNumber}
              onChange={(e) => setModelNumber(e.target.value)}
            />
          </div>
        </div>

        <div className="flex gap-3">
          <div className="flex flex-column">
            <label htmlFor="productID">Type</label>
            <InputText
              type="text"
              value={type}
              onChange={(e) => setType(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">Age</label>
            <InputText
              type="text"
              value={ageGroup}
              onChange={(e) => setAgeGroup(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">Maximum Weight</label>
            <InputText
              type="text"
              value={maximumUserWeight}
              onChange={(e) => setMaximumUserWeight(e.target.value)}
            />
          </div>
        </div>

        <div className="flex gap-3">
          <div className="flex flex-column">
            <label htmlFor="productID">NetQuantity</label>
            <InputText
              type="text"
              value={netQuantity}
              onChange={(e) => setNetQuantity(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">Speed</label>
            <InputText
              type="text"
              value={speed}
              onChange={(e) => setSpeed(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">Delivery Condition</label>
            <InputText
              type="text"
              value={deliveryCondition}
              onChange={(e) => setDeliveryCondition(e.target.value)}
            />
          </div>
        </div>
        <div className="flex gap-3">
          <div className="flex flex-column">
            <label htmlFor="productID">No Of Seats</label>
            <InputText
              type="text"
              value={numberOfSeats}
              onChange={(e) => setNumberOfSeats(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">BatteryOperated</label>
            <InputText
              type="text"
              value={batteryOperated}
              onChange={(e) => setBatteryOperated(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">No Of Batteries</label>
            <InputText
              type="text"
              value={noOfBatteries}
              onChange={(e) => setNoOfBatteries(e.target.value)}
            />
          </div>
        </div>

        <div className="flex gap-3">
          <div className="flex flex-column">
            <label htmlFor="productID">Battry Included</label>
            <InputText
              type="text"
              value={batteryIncluded}
              onChange={(e) => setBatteryIncluded(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">Rechargable</label>
            <InputText
              type="text"
              value={rechargeable}
              onChange={(e) => setRechargeable(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">Battery Type</label>
            <InputText
              type="text"
              value={batteryType}
              onChange={(e) => setBatteryType(e.target.value)}
            />
          </div>
        </div>

        <div className="flex gap-3">
          <div className="flex flex-column">
            <label htmlFor="productID">Other Power Details</label>
            <InputText
              type="text"
              value={otherPowerFeatures}
              onChange={(e) => setOtherPowerFeatures(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">Key Start</label>
            <InputText
              type="text"
              value={keyStart}
              onChange={(e) => setKeyStart(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">seatbeltIncluded</label>
            <InputText
              type="text"
              value={seatbeltIncluded}
              onChange={(e) => setSeatbeltIncluded(e.target.value)}
            />
          </div>
        </div>

        <div className="flex gap-3">
          <div className="flex flex-column">
            <label htmlFor="productID">mp3Player</label>
            <InputText
              type="text"
              value={mpThreePlayerSupported}
              onChange={(e) => setMpThreePlayerSupported(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">Parental Remote</label>
            <InputText
              type="text"
              value={parentalRemote}
              onChange={(e) => setParentalRemote(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">lights</label>
            <InputText
              type="text"
              value={lights}
              onChange={(e) => setLights(e.target.value)}
            />
          </div>
        </div>
        <div className="flex gap-3">
          <div className="flex flex-column">
            <label htmlFor="productID">Horn</label>
            <InputText
              type="text"
              value={horn}
              onChange={(e) => setHorn(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">OtherFeatures</label>
            <InputText
              type="text"
              value={otherConvenienceFeatures}
              onChange={(e) => setOtherConvenienceFeatures(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">Dimentions</label>
            <InputText
              type="text"
              value={dimentions}
              onChange={(e) => setDimentions(e.target.value)}
            />
          </div>
        </div>
        <div className="flex gap-3">
          <div className="flex flex-column">
            <label htmlFor="productID">weight</label>
            <InputText
              type="text"
              value={weight}
              onChange={(e) => setWeight(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">Country</label>
            <InputText
              type="text"
              value={countryOfOrigin}
              onChange={(e) => setCountryOfOrigin(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">Manufacter</label>
            <InputText
              type="text"
              value={manufacturer}
              onChange={(e) => setManufacturer(e.target.value)}
            />
          </div>
        </div>

        <div className="flex gap-3">
          <div className="flex flex-column">
            <label htmlFor="productID">warrenty</label>
            <InputText
              type="text"
              value={warrenty}
              onChange={(e) => setWarrenty(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">Coverd In warrenty</label>
            <InputText
              type="text"
              value={coveredInWarranty}
              onChange={(e) => setCoveredInWarranty(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">NotCoverd In Warrenty</label>
            <InputText
              type="text"
              value={notCoveredInWarranty}
              onChange={(e) => setNotCoveredInWarranty(e.target.value)}
            />
          </div>
        </div>

        <div className="flex gap-3">
          <div className="flex flex-column">
            <label htmlFor="productID">color</label>
            <InputText
              type="text"
              value={color}
              onChange={(e) => setColor(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">Quantity</label>
            <InputText
              type="text"
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productID">Stock Availability</label>
            <InputText
              type="text"
              value={stockAvailability}
              onChange={(e) => setStockAvailability(e.target.value)}
            />
          </div>
        </div>

        <Button
          type="submit"
          onClick={(e) => {
            handleSubmitUpdate(e);
          }}
          label="Submit"
        />
      </Dialog>
      <Card className="m-2">
        <Button
          security="info"
          label="Add"
          size="small"
          onClick={() => {
            setShowAddDialog(true);
          }}
        />
        <DataTable
          value={products}
          tableStyle={{ minWidth: "50rem" }}
          loading={loading}
          scrollable
          scrollHeight="400px"
          className="allDataTableThCenterCommon"
          resizableColumns
          size="small"
          rows={10}
          rowsPerPageOptions={[5, 10, 15, 25, 50]}
          paginator
          removableSort
          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
          currentPageReportTemplate="{first} to {last} of {totalRecords}"
          showGridlines
          emptyMessage="No Data found."
        >
          {/* <Column field="productID" header="ProductID" frozen></Column> */}
          {/* <Column
            field="productID"
            header="Product ID"
            frozen
            body={(item) => (
              <span
                style={{
                  cursor: "pointer",
                  color: "blue",
                  textDecoration: "underline",
                }}
                onClick={() => {
                  navigate(`/carsById/${item.productID}`, {
                    state: { product: item },
                  });
                  sessionStorage.setItem("productId", item.productID);
                }}
              >
                {item.productID}
              </span>
            )}
          /> */}

          <Column
            field="productID"
            header="Product ID"
            frozen
            body={(item) => (
              <span
                style={{
                  cursor: "pointer",
                  color: "blue",
                  textDecoration: "underline",
                }}
                onClick={() => {
                  sessionStorage.setItem("productId", item.productID); // to be used by SingleProductCars
                  setSelectedProductID(item.productID); // optional
                  setVisibleDialog(true);
                }}
              >
                {item.productID}
              </span>
            )}
          />

          {/* <Column field="productName" header="Name"></Column> */}
          <Column
            field="productName"
            header="Name"
            body={(rowData) => (
              <span title={rowData.productName}>
                {rowData.productName.length > 50
                  ? rowData.productName.substring(0, 50) + "..."
                  : rowData.productName}
              </span>
            )}
          ></Column>
          {/* <Column field="description" header="Description"></Column> */}
          <Column
            field="description"
            header="Description"
            body={(rowData) => (
              <span title={rowData.description}>
                {rowData.description.length > 50
                  ? rowData.description.substring(0, 50) + "..."
                  : rowData.description}
              </span>
            )}
          ></Column>

          {/* <Column field="category" header="Category"></Column> */}
          <Column field="quantity" header="Quantity"></Column>
          <Column header="Action" body={handleEditRowClick}></Column>
        </DataTable>
      </Card>
    </div>
  );
}

export default TabViewGiftsAndArts;
